'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nameToClassnames = {
  up: 'dp-IconArrow iconArrow--top',
  down: 'dp-IconArrow',
  left: 'dp-IconArrow iconArrow--left',
  right: 'dp-IconArrow iconArrow--right',
  add: 'dp-IconPlus',
  close: 'dp-IconClose',
  edit: 'dp-IconEdit',
  lock: 'dp-IconLock',
  refresh: 'dp-RefreshIcon',
  refreshed: 'dp-RefreshIcon is-updated',
  refreshing: 'dp-RefreshIcon is-updating',
  search: 'dp-IconSearch',
  tag: 'dp-IconTag',
  open: 'dp-IconOpen',
  link: 'dp-IconLink',
  unlink: 'dp-IconUnlink',
  settings: 'dp-IconSettings'
};

/**
 * @param {string} name
 * @param {string} [className]
 * @param [children]
 * @return {*}
 * @constructor
 */
var Icon = function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'i',
    { className: (0, _classnames2.default)(nameToClassnames[name], className) },
    children
  );
};

Icon.propTypes = {

  className: _propTypes2.default.string,

  name: _propTypes2.default.string.isRequired
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Icon/Icon.js
// module id = 334
// module chunks = 0